import styled from "styled-components";

export const Wrap = styled.div`
    position: relative;
    width: 400px;
    padding: 20px;
    border: 1px solid #000;
`
export const DropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    width: inherit;
    padding: 20px;
    text-align: center;
    background-color: #fff;
`